import React, { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PuneetShareClass = () => {
  const BaseUrl = process.env.REACT_APP_API;

  const [data, setData] = useState({
    subAccount3: null,
    totalAUM: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ sub3] = await Promise.all([
          axios.get(`${BaseUrl}/api/binance/balance/sub3`),
        ]);

        const totalAUM =
          parseFloat(sub3.data.totalBalanceUSDT);

        setData({
          subAccount3: sub3.data,
          totalAUM,
        });
      } catch (error) {
        console.error("Error fetching Binance data:", error);
      }
    };

    fetchData();
  }, []);

  // Function to calculate percentage
  const calculatePercentage = (balance, total) => {
    return ((balance / total) * 100).toFixed(2) + "%";
  };

  // Function to render table
  const renderTable = (account, name) => {
    if (!account) return null;

    return (
      <div className="card basic-data-table">
        <div className="card-header">
          <h5 className="card-title mb-0">{name}</h5>
        </div>
        <div className="card-body overflow-auto p-2" style={{ maxHeight: "300px" }}>
          <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
            <thead>
              <tr>
                <th>Wallet Name</th>
                <th>Balance in BTC</th>
                <th>Balance in USD</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              {account.balances?.map((wallet, index) => (
                <tr key={index}>
                  <td>{wallet.walletName}</td>
                  <td>{wallet.originalBalance}</td>
                  <td>${wallet.balanceInUSD}</td>
                  <td>{calculatePercentage(wallet.balanceInUSD, account.totalBalanceUSDT)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="card-header text-white">
          <h6 className="mb-0">Total: ${account.totalBalanceUSDT}</h6>
        </div>
      </div>
    );
  };

  // Pie Chart Data
  const chartData = {
    labels: [
      `Main Account (${calculatePercentage(data.mainAccount?.totalBalanceUSDT || 0, data.totalAUM)})`,
      `Keshav Account (${calculatePercentage(data.subAccount1?.totalBalanceUSDT || 0, data.totalAUM)})`,
      `QI Cap Account (${calculatePercentage(data.subAccount2?.totalBalanceUSDT || 0, data.totalAUM)})`,
      `Puneet Account (${calculatePercentage(data.subAccount3?.totalBalanceUSDT || 0, data.totalAUM)})`,
    ],
    datasets: [
      {
        data: [
          data.mainAccount?.totalBalanceUSDT || 0,
          data.subAccount1?.totalBalanceUSDT || 0,
          data.subAccount2?.totalBalanceUSDT || 0,
          data.subAccount3?.totalBalanceUSDT || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
      },
    ],
  };

  return (
    <div id="msform" className="container mt-4">
    
   <div className="mb-12">
  <h2 className="text-2xl font-bold mb-4">Puneet Account Other Share-class</h2>
  {renderTable(data.subAccount3)}
</div>
            </div>
          );
};

export default PuneetShareClass;